import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import store from '../../store';
import getParameterFromURL from '../../utils/scripts/getParameterFromURL';
import s from './index.module.scss';

function ProgressBarV2() {
  const { T } = useT();
  const currentStepIndex = useSelector((state) => state.steps.currentStepIndex);
  const sv2 = getParameterFromURL('sv') === '2';
  const customV2 = getParameterFromURL('config') === 'customV2';
  const customV3 = getParameterFromURL('config') === 'customV3';
  const customV4 = getParameterFromURL('config') === 'customV4';
  const customV5 = getParameterFromURL('config') === 'customV5';
  const customV7 = getParameterFromURL('config') === 'customV7';
  const customV10 = getParameterFromURL('config') === 'customV10';
  const customV11 = getParameterFromURL('config') === 'customV11';
  const customV12 = getParameterFromURL('config') === 'customV12';
  const customV13 = getParameterFromURL('config') === 'customV13';
  const customV18 = getParameterFromURL('config') === 'customV18';
  const customV20 = getParameterFromURL('config') === 'customV20';
  const customV21 = getParameterFromURL('config') === 'customV21';
  const customV22 = getParameterFromURL('config') === 'customV22';
  const customV24 = getParameterFromURL('config') === 'customV24';
  const customV28 = getParameterFromURL('config') === 'customV28';
  const customV43 = getParameterFromURL('config') === 'customV43';
  const customV44 = getParameterFromURL('config') === 'customV44';
  // const customV29 = getParameterFromURL('config') === 'customV29';
  const customV32 = getParameterFromURL('config') === 'customV32' || getParameterFromURL('config') === 'customV33';
  // const totalSteps = useSelector((state) => state.steps.totalSteps);
  const { currentStep } = store.getState().steps;
  const [progress, setProgress] = useState(0);
  const [title, setTitle] = useState(T('customV2_progress_text1'));
  const [titleNumberStep, setTitleNumberStep] = useState('1/1');
  const tariff = getParameterFromURL('tariff') || null;
  const everydoggyV5 = getParameterFromURL('everydoggyV5') === 'true';
  // const mix = getParameterFromURL('mix') === 'true';
  // const firstScreenAB = localStorage.getItem('p10_firstScreens_zw') === 'B';
  // const firstScreenAB = customV2 && everydoggyV5 && !tariff;
  const firstScreenAB = false;

  const p13MixFirstScreenTitle = false;
  // const p13MixFirstScreenTitle = (localStorage.getItem('p13_mix_firstScreen_title') === 'B' || localStorage.getItem('p13_mix_firstScreen_title') === 'C') && !mix;
  
  useEffect(() => {
    let progressValue = 0;

    if (customV3) {
      if (currentStepIndex === 0) {
        progressValue = 4;
        setTitleNumberStep('1/5');
      }
      if (currentStepIndex === 1) {
        progressValue = 12;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 2) {
        progressValue = 18;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 3) {
        progressValue = 23;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 4) {
        progressValue = 28;
        setTitleNumberStep('5/5');
      }
  
      if (currentStepIndex === 5) {
        progressValue = 33;
      }
  
      if (currentStepIndex === 6) {
        progressValue = 39;
        setTitleNumberStep('1/4');
      }
      if (currentStepIndex === 7) {
        progressValue = 45;
        setTitleNumberStep('2/4');
      }
      if (currentStepIndex === 8) {
        progressValue = 51;
        setTitleNumberStep('3/4');
      }
      if (currentStepIndex === 9) {
        progressValue = 57;
        setTitleNumberStep('4/4');
      }
  
      if (currentStepIndex === 10) {
        progressValue = 66;
      }
  
      if (currentStepIndex === 11) {
        progressValue = 72;
        setTitleNumberStep('1/5');
      }
      if (currentStepIndex === 12) {
        progressValue = 78;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 13) {
        progressValue = 84;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 14) {
        progressValue = 90;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 15) {
        progressValue = 98;
        setTitleNumberStep('5/5');
      }
    } else if (customV32) {
      if (currentStepIndex === 1) {
        progressValue = 10;
      }
      if (currentStepIndex === 2) {
        progressValue = 17;
      }
      if (currentStepIndex === 3) {
        progressValue = 24;
      }
      if (currentStepIndex === 4) {
        progressValue = 31;
      }
      if (currentStepIndex === 5) {
        progressValue = 38;
      }
      if (currentStepIndex === 6) {
        progressValue = 42;
      }
      if (currentStepIndex === 7) {
        progressValue = 59;
      }
      if (currentStepIndex === 8) {
        progressValue = 66;
      }
      if (currentStepIndex === 9) {
        progressValue = 73;
      }
      if (currentStepIndex === 10) {
        progressValue = 78;
      }
      if (currentStepIndex === 11) {
        progressValue = 83;
      }
      if (currentStepIndex === 12) {
        progressValue = 89;
      }
      if (currentStepIndex === 13) {
        progressValue = 90;
      }
      if (currentStepIndex === 14) {
        progressValue = 94;
      }
      if (currentStepIndex === 15) {
        progressValue = 98;
      }
      if (currentStepIndex === 16) {
        progressValue = 100;
      }
    } else if (customV4 || customV10 || customV13) {
      if (currentStepIndex === 1) {
        progressValue = 4;
        setTitleNumberStep('1/5');
      }
      if (currentStepIndex === 2) {
        progressValue = 12;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 3) {
        progressValue = 18;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 4) {
        progressValue = 23;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 5) {
        progressValue = 28;
        setTitleNumberStep('5/5');
      }
  
      if (currentStepIndex === 6) {
        progressValue = 33;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 39;
        setTitleNumberStep('1/4');
      }
      if (currentStepIndex === 8) {
        progressValue = 45;
        setTitleNumberStep('2/4');
      }
      if (currentStepIndex === 9) {
        progressValue = 51;
        setTitleNumberStep('3/4');
      }
      if (currentStepIndex === 10) {
        progressValue = 57;
        setTitleNumberStep('4/4');
      }
  
      if (currentStepIndex === 11) {
        progressValue = 66;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 72;
        setTitleNumberStep('1/5');
      }
      if (currentStepIndex === 13) {
        progressValue = 78;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 14) {
        progressValue = 84;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 15) {
        progressValue = 90;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 16) {
        progressValue = 98;
        setTitleNumberStep('5/5');
      }
    } else if (customV5) {
      if (currentStepIndex === 1) {
        progressValue = 4;
        setTitleNumberStep('1/5');
      }
      if (currentStepIndex === 2) {
        progressValue = 12;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 3) {
        progressValue = 18;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 4) {
        progressValue = 23;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 5) {
        progressValue = 28;
        setTitleNumberStep('5/5');
      }
  
      if (currentStepIndex === 6) {
        progressValue = 33;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 39;
        setTitleNumberStep('1/4');
      }
      if (currentStepIndex === 8) {
        progressValue = 45;
        setTitleNumberStep('2/4');
      }
      if (currentStepIndex === 9) {
        progressValue = 51;
        setTitleNumberStep('3/4');
      }
      if (currentStepIndex === 10) {
        progressValue = 57;
        setTitleNumberStep('4/4');
      }
  
      if (currentStepIndex === 11) {
        progressValue = 66;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 72;
        setTitleNumberStep('1/5');
      }
      if (currentStepIndex === 13) {
        progressValue = 78;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 14) {
        progressValue = 84;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 15) {
        progressValue = 90;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 16) {
        progressValue = 98;
        setTitleNumberStep('5/5');
      }
    } else if (customV7) {
      if (currentStepIndex === 1) {
        progressValue = 8;
      }
      if (currentStepIndex === 2) {
        progressValue = 16;
      }
      if (currentStepIndex === 3) {
        progressValue = 28;
      }
      if (currentStepIndex === 4) {
        progressValue = 32;
      }
      if (currentStepIndex === 5) {
        progressValue = 40;
      }
  
      if (currentStepIndex === 6) {
        progressValue = 48;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 56;
      }
      if (currentStepIndex === 8) {
        progressValue = 62;
      }
      if (currentStepIndex === 9) {
        progressValue = 64;
      }
      if (currentStepIndex === 10) {
        progressValue = 72;
      }
  
      if (currentStepIndex === 11) {
        progressValue = 88;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 100;
      }
    } else if (customV11) {
      if (currentStepIndex === 1) {
        progressValue = 4;
      }
      if (currentStepIndex === 2) {
        progressValue = 12;
      }
      if (currentStepIndex === 3) {
        progressValue = 18;
      }
      if (currentStepIndex === 4) {
        progressValue = 23;
      }
      if (currentStepIndex === 5) {
        progressValue = 28;
      }
  
      if (currentStepIndex === 6) {
        progressValue = 39;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 45;
      }
      if (currentStepIndex === 8) {
        progressValue = 51;
      }
      if (currentStepIndex === 9) {
        progressValue = 57;
      }
      if (currentStepIndex === 10) {
        progressValue = 66;
      }
  
      if (currentStepIndex === 11) {
        progressValue = 72;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 78;
      }
      if (currentStepIndex === 13) {
        progressValue = 84;
      }
      if (currentStepIndex === 14) {
        progressValue = 90;
      }
      if (currentStepIndex === 15) {
        progressValue = 98;
      }
    } else if (customV12) {
      if (currentStepIndex === 1) {
        progressValue = 4;
      }
      if (currentStepIndex === 2) {
        progressValue = 8;
      }
      if (currentStepIndex === 3) {
        progressValue = 16;
      }
      if (currentStepIndex === 4) {
        progressValue = 28;
      }
      if (currentStepIndex === 5) {
        progressValue = 32;
      }
  
      if (currentStepIndex === 6) {
        progressValue = 40;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 48;
      }
      if (currentStepIndex === 8) {
        progressValue = 56;
      }
      if (currentStepIndex === 9) {
        progressValue = 62;
      }
      if (currentStepIndex === 10) {
        progressValue = 64;
      }
  
      if (currentStepIndex === 11) {
        progressValue = 72;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 88;
      }

      if (currentStepIndex === 13) {
        progressValue = 100;
      }
    } else if (customV2 && tariff === 'v17') {
      if (currentStepIndex === 2) {
        progressValue = 4;
      }
      if (currentStepIndex === 3) {
        progressValue = 12;
      }
      if (currentStepIndex === 4) {
        progressValue = 18;
      }
      if (currentStepIndex === 5) {
        progressValue = 23;
      }
      if (currentStepIndex === 6) {
        progressValue = 28;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 33;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 39;
      }
      if (currentStepIndex === 9) {
        progressValue = 45;
      }
      if (currentStepIndex === 10) {
        progressValue = 51;
      }
      if (currentStepIndex === 11) {
        progressValue = 57;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 66;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 68;
      }
      if (currentStepIndex === 14) {
        progressValue = 72;
      }
      if (currentStepIndex === 15) {
        progressValue = 76;
      }
      if (currentStepIndex === 16) {
        progressValue = 80;
      }
      if (currentStepIndex === 17) {
        progressValue = 84;
      }
      if (currentStepIndex === 18) {
        progressValue = 88;
      }
      if (currentStepIndex === 19) {
        progressValue = 92;
      }
      if (currentStepIndex === 20) {
        progressValue = 98;
      }
    } else if (customV2 && (tariff && tariff !== 'v17') && !p13MixFirstScreenTitle) {
      if (currentStepIndex === 1) {
        progressValue = 4;
      }
      if (currentStepIndex === 2) {
        progressValue = 10;
      }
      if (currentStepIndex === 3) {
        progressValue = 16;
      }
      if (currentStepIndex === 4) {
        progressValue = 22;
      }
      if (currentStepIndex === 5) {
        progressValue = 25;
      }
      if (currentStepIndex === 6) {
        progressValue = 30;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 41;
      }
      if (currentStepIndex === 9) {
        progressValue = 48;
      }
      if (currentStepIndex === 10) {
        progressValue = 54;
      }
      if (currentStepIndex === 11) {
        progressValue = 57;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 70;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 70;
      }
      if (currentStepIndex === 14) {
        progressValue = 73;
      }
      if (currentStepIndex === 15) {
        progressValue = 76;
      }
      if (currentStepIndex === 16) {
        progressValue = 80;
      }
      if (currentStepIndex === 17) {
        progressValue = 83;
      }
      if (currentStepIndex === 18) {
        progressValue = 86;
      }
      if (currentStepIndex === 19) {
        progressValue = 89;
      }
      if (currentStepIndex === 20) {
        progressValue = 92;
      }
      if (currentStepIndex === 21) {
        progressValue = 95;
      }
      if (currentStepIndex === 22) {
        progressValue = 98;
      }
    } else if (customV2 && (tariff && tariff !== 'v17') && p13MixFirstScreenTitle) {
      if (currentStepIndex === 1) {
        progressValue = 4;
      }
      if (currentStepIndex === 2) {
        progressValue = 10;
      }
      if (currentStepIndex === 3) {
        progressValue = 16;
      }
      if (currentStepIndex === 4) {
        progressValue = 22;
      }
      if (currentStepIndex === 5) {
        progressValue = 25;
      }
      if (currentStepIndex === 6) {
        progressValue = 30;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 41;
      }
      if (currentStepIndex === 9) {
        progressValue = 48;
      }
      if (currentStepIndex === 10) {
        progressValue = 54;
      }
      if (currentStepIndex === 11) {
        progressValue = 57;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 62;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 70;
      }
      if (currentStepIndex === 14) {
        progressValue = 73;
      }
      if (currentStepIndex === 15) {
        progressValue = 76;
      }
      if (currentStepIndex === 16) {
        progressValue = 80;
      }
      if (currentStepIndex === 17) {
        progressValue = 83;
      }
      if (currentStepIndex === 18) {
        progressValue = 86;
      }
      if (currentStepIndex === 19) {
        progressValue = 89;
      }
      if (currentStepIndex === 20) {
        progressValue = 92;
      }
      if (currentStepIndex === 21) {
        progressValue = 95;
      }
      if (currentStepIndex === 22) {
        progressValue = 98;
      }
    } else if (customV21) {
      if (currentStepIndex === 1) {
        progressValue = 7;
      }
      if (currentStepIndex === 2) {
        progressValue = 15;
      }
      if (currentStepIndex === 3) {
        progressValue = 23;
      }
      if (currentStepIndex === 4) {
        progressValue = 30;
      }
      if (currentStepIndex === 5) {
        progressValue = 32;
      }
      if (currentStepIndex === 6) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 43;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 48;
      }
      if (currentStepIndex === 9) {
        progressValue = 52;
      }
      if (currentStepIndex === 10) {
        progressValue = 56;
      }
      if (currentStepIndex === 11) {
        progressValue = 60;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 64;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 68;
      }
      if (currentStepIndex === 14) {
        progressValue = 80;
      }
      if (currentStepIndex === 15) {
        progressValue = 92;
      }
      if (currentStepIndex === 16) {
        progressValue = 100;
      }
      if (currentStepIndex === 17) {
        progressValue = 100;
      }
    } else if (customV20) {
      if (currentStepIndex === 1) {
        progressValue = 8;
      }
      if (currentStepIndex === 2) {
        progressValue = 16;
      }
      if (currentStepIndex === 3) {
        progressValue = 24;
      }
      if (currentStepIndex === 4) {
        progressValue = 28;
      }
      if (currentStepIndex === 5) {
        progressValue = 32;
      }
      if (currentStepIndex === 6) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 42;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 46;
      }
      if (currentStepIndex === 9) {
        progressValue = 51;
      }
      if (currentStepIndex === 10) {
        progressValue = 56;
      }
      if (currentStepIndex === 11) {
        progressValue = 60;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 66;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 70;
      }
      if (currentStepIndex === 14) {
        progressValue = 77;
      }
      if (currentStepIndex === 15) {
        progressValue = 84;
      }
      if (currentStepIndex === 16) {
        progressValue = 91;
      }
      if (currentStepIndex === 17) {
        progressValue = 98;
      }
      if (currentStepIndex === 18) {
        progressValue = 100;
      }
    } else if (customV22 || customV18) {
      if (currentStepIndex === 1) {
        progressValue = 4;
      }
      if (currentStepIndex === 2) {
        progressValue = 10;
      }
      if (currentStepIndex === 3) {
        progressValue = 16;
      }
      if (currentStepIndex === 4) {
        progressValue = 22;
      }
      if (currentStepIndex === 5) {
        progressValue = 30;
      }
      if (currentStepIndex === 6) {
        progressValue = 30;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 41;
      }
      if (currentStepIndex === 9) {
        progressValue = 48;
      }
      if (currentStepIndex === 10) {
        progressValue = 54;
      }
      if (currentStepIndex === 11) {
        progressValue = 57;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 70;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 72;
      }
      if (currentStepIndex === 14) {
        progressValue = 75;
      }
      if (currentStepIndex === 15) {
        progressValue = 79;
      }
      if (currentStepIndex === 16) {
        progressValue = 82;
      }
      if (currentStepIndex === 17) {
        progressValue = 85;
      }
      if (currentStepIndex === 18) {
        progressValue = 89;
      }
      if (currentStepIndex === 19) {
        progressValue = 92;
      }
      if (currentStepIndex === 20) {
        progressValue = 95;
      }
      if (currentStepIndex === 21) {
        progressValue = 98;
      }
      if (currentStepIndex === 22) {
        progressValue = 100;
      }
    } else if (customV24) {
      if (currentStepIndex === 1) {
        progressValue = 6;
      }
      if (currentStepIndex === 2) {
        progressValue = 12;
      }
      if (currentStepIndex === 3) {
        progressValue = 18;
      }
      if (currentStepIndex === 4) {
        progressValue = 26;
      }
      if (currentStepIndex === 5) {
        progressValue = 30;
      }
      if (currentStepIndex === 6) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 41;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 48;
      }
      if (currentStepIndex === 9) {
        progressValue = 54;
      }
      if (currentStepIndex === 10) {
        progressValue = 57;
      }
      if (currentStepIndex === 11) {
        progressValue = 70;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 72;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 76;
      }
      if (currentStepIndex === 14) {
        progressValue = 80;
      }
      if (currentStepIndex === 15) {
        progressValue = 84;
      }
      if (currentStepIndex === 16) {
        progressValue = 88;
      }
      if (currentStepIndex === 17) {
        progressValue = 92;
      }
      if (currentStepIndex === 18) {
        progressValue = 98;
      }
      if (currentStepIndex === 19) {
        progressValue = 98;
      }
    } else if ((customV2 && !tariff && !everydoggyV5) || (customV2 && everydoggyV5 && !tariff && !firstScreenAB)) {
      if (currentStepIndex === 0) {
        progressValue = 4;
      }
      if (currentStepIndex === 1) {
        progressValue = 7;
      }
      if (currentStepIndex === 2) {
        progressValue = 10;
      }
      if (currentStepIndex === 3) {
        progressValue = 16;
      }
      if (currentStepIndex === 4) {
        progressValue = 30;
      }
      if (currentStepIndex === 5) {
        progressValue = 30;
      }
      if (currentStepIndex === 6) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 41;
      }
      if (currentStepIndex === 8) {
        progressValue = 48;
      }
      if (currentStepIndex === 9) {
        progressValue = 54;
      }
      if (currentStepIndex === 10) {
        progressValue = 60;
      }
      if (currentStepIndex === 11) {
        progressValue = 65;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 70;
      }
      if (currentStepIndex === 13) {
        progressValue = 73;
      }
      if (currentStepIndex === 14) {
        progressValue = 76;
      }
      if (currentStepIndex === 15) {
        progressValue = 80;
      }
      if (currentStepIndex === 16) {
        progressValue = 83;
      }
      if (currentStepIndex === 17) {
        progressValue = 86;
      }
      if (currentStepIndex === 18) {
        progressValue = 89;
      }
      if (currentStepIndex === 19) {
        progressValue = 92;
      }
      if (currentStepIndex === 20) {
        progressValue = 95;
      }
      if (currentStepIndex === 21) {
        progressValue = 98;
      }
    } else if (customV28) {
      if (currentStepIndex === 2) {
        progressValue = 4;
      }
      if (currentStepIndex === 3) {
        progressValue = 10;
      }
      if (currentStepIndex === 4) {
        progressValue = 16;
      }
      if (currentStepIndex === 5) {
        progressValue = 22;
      }
      if (currentStepIndex === 6) {
        progressValue = 30;
      }
      if (currentStepIndex === 7) {
        progressValue = 30;
      }
  
      if (currentStepIndex === 8) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 9) {
        progressValue = 41;
      }
      if (currentStepIndex === 10) {
        progressValue = 48;
      }
      if (currentStepIndex === 11) {
        progressValue = 54;
      }
      if (currentStepIndex === 12) {
        progressValue = 57;
      }
  
      if (currentStepIndex === 13) {
        progressValue = 70;
      }
  
      if (currentStepIndex === 14) {
        progressValue = 70;
      }
      if (currentStepIndex === 15) {
        progressValue = 73;
      }
      if (currentStepIndex === 16) {
        progressValue = 76;
      }
      if (currentStepIndex === 17) {
        progressValue = 80;
      }
      if (currentStepIndex === 18) {
        progressValue = 83;
      }
      if (currentStepIndex === 19) {
        progressValue = 86;
      }
      if (currentStepIndex === 20) {
        progressValue = 89;
      }
      if (currentStepIndex === 21) {
        progressValue = 92;
      }
      if (currentStepIndex === 22) {
        progressValue = 95;
      }
      if (currentStepIndex === 23) {
        progressValue = 98;
      }
    } else if (customV2 && everydoggyV5 && !tariff && firstScreenAB) {
      if (currentStepIndex === 0) {
        progressValue = 4;
        setTitleNumberStep('1/5');
      }
      if (currentStepIndex === 1) {
        progressValue = 10;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 2) {
        progressValue = 16;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 3) {
        progressValue = 21;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 4) {
        progressValue = 26;
        setTitleNumberStep('5/5');
      }
      if (currentStepIndex === 5) {
        progressValue = 30;
      }
  
      if (currentStepIndex === 6) {
        progressValue = 38;
        setTitleNumberStep('1/5');
      }
  
      if (currentStepIndex === 7) {
        progressValue = 41;
        setTitleNumberStep('2/5');
      }
      if (currentStepIndex === 8) {
        progressValue = 48;
        setTitleNumberStep('3/5');
      }
      if (currentStepIndex === 9) {
        progressValue = 54;
        setTitleNumberStep('4/5');
      }
      if (currentStepIndex === 10) {
        progressValue = 57;
        setTitleNumberStep('5/5');
      }
  
      if (currentStepIndex === 11) {
        progressValue = 70;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 70;
        setTitleNumberStep('1/9');
      }
      if (currentStepIndex === 13) {
        progressValue = 73;
        setTitleNumberStep('2/9');
      }
      if (currentStepIndex === 14) {
        progressValue = 76;
        setTitleNumberStep('3/9');
      }
      if (currentStepIndex === 15) {
        progressValue = 80;
        setTitleNumberStep('4/9');
      }
      if (currentStepIndex === 16) {
        progressValue = 83;
        setTitleNumberStep('5/9');
      }
      if (currentStepIndex === 17) {
        progressValue = 86;
        setTitleNumberStep('6/9');
      }
      if (currentStepIndex === 18) {
        progressValue = 89;
      }
      if (currentStepIndex === 19) {
        progressValue = 92;
        setTitleNumberStep('7/9');
      }
      if (currentStepIndex === 20) {
        progressValue = 95;
        setTitleNumberStep('8/9');
      }
      if (currentStepIndex === 21) {
        progressValue = 98;
        setTitleNumberStep('9/9');
      }
    } else if (customV43) {
      if (currentStepIndex === 3) {
        progressValue = 4;
      }
      if (currentStepIndex === 4) {
        progressValue = 7;
      }
      if (currentStepIndex === 5) {
        progressValue = 10;
      }
      if (currentStepIndex === 6) {
        progressValue = 16;
      }
      if (currentStepIndex === 7) {
        progressValue = 25;
      }
      if (currentStepIndex === 8) {
        progressValue = 32;
      }
      if (currentStepIndex === 9) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 10) {
        progressValue = 41;
      }
      if (currentStepIndex === 11) {
        progressValue = 48;
      }
      if (currentStepIndex === 12) {
        progressValue = 54;
      }
      if (currentStepIndex === 13) {
        progressValue = 60;
      }
      if (currentStepIndex === 14) {
        progressValue = 65;
      }
  
      if (currentStepIndex === 15) {
        progressValue = 70;
      }
      if (currentStepIndex === 16) {
        progressValue = 73;
      }
      if (currentStepIndex === 17) {
        progressValue = 76;
      }
      if (currentStepIndex === 18) {
        progressValue = 80;
      }
      if (currentStepIndex === 19) {
        progressValue = 83;
      }
      if (currentStepIndex === 20) {
        progressValue = 86;
      }
      if (currentStepIndex === 21) {
        progressValue = 89;
      }
      if (currentStepIndex === 22) {
        progressValue = 92;
      }
      if (currentStepIndex === 23) {
        progressValue = 95;
      }
      if (currentStepIndex === 24) {
        progressValue = 98;
      }
    } else if (customV44) {
      if (currentStepIndex === 1) {
        progressValue = 4;
      }
      if (currentStepIndex === 2) {
        progressValue = 7;
      }
      if (currentStepIndex === 3) {
        progressValue = 10;
      }
      if (currentStepIndex === 4) {
        progressValue = 16;
      }
      if (currentStepIndex === 5) {
        progressValue = 25;
      }
      if (currentStepIndex === 6) {
        progressValue = 32;
      }

      if (currentStepIndex === 7) {
        progressValue = 38;
      }
      if (currentStepIndex === 8) {
        progressValue = 42;
      }
      if (currentStepIndex === 9) {
        progressValue = 46;
      }
      if (currentStepIndex === 10) {
        progressValue = 50;
      }
      if (currentStepIndex === 13) {
        progressValue = 54;
      }
      if (currentStepIndex === 11) {
        progressValue = 58;
      }
      if (currentStepIndex === 12) {
        progressValue = 62;
      }
      if (currentStepIndex === 13) {
        progressValue = 66;
      }
  
      if (currentStepIndex === 15) {
        progressValue = 70;
      }
      if (currentStepIndex === 16) {
        progressValue = 74;
      }
      if (currentStepIndex === 17) {
        progressValue = 78;
      }
      if (currentStepIndex === 18) {
        progressValue = 82;
      }
      if (currentStepIndex === 19) {
        progressValue = 86;
      }
      if (currentStepIndex === 20) {
        progressValue = 90;
      }
      if (currentStepIndex === 21) {
        progressValue = 94;
      }
      if (currentStepIndex === 22) {
        progressValue = 98;
      }
      if (currentStepIndex === 23) {
        progressValue = 100;
      }
      if (currentStepIndex === 24) {
        progressValue = 98;
      }
    } else {
      if (currentStepIndex === 0) {
        progressValue = 4;
      }
      if (currentStepIndex === 1) {
        progressValue = 7;
      }
      if (currentStepIndex === 2) {
        progressValue = 10;
      }
      if (currentStepIndex === 3) {
        progressValue = 16;
      }
      if (currentStepIndex === 4) {
        progressValue = 25;
      }
      if (currentStepIndex === 5) {
        progressValue = 32;
      }
      if (currentStepIndex === 6) {
        progressValue = 38;
      }
  
      if (currentStepIndex === 7) {
        progressValue = 41;
      }
      if (currentStepIndex === 8) {
        progressValue = 48;
      }
      if (currentStepIndex === 9) {
        progressValue = 54;
      }
      if (currentStepIndex === 10) {
        progressValue = 60;
      }
      if (currentStepIndex === 11) {
        progressValue = 65;
      }
  
      if (currentStepIndex === 12) {
        progressValue = 70;
      }
      if (currentStepIndex === 13) {
        progressValue = 73;
      }
      if (currentStepIndex === 14) {
        progressValue = 76;
      }
      if (currentStepIndex === 15) {
        progressValue = 80;
      }
      if (currentStepIndex === 16) {
        progressValue = 83;
      }
      if (currentStepIndex === 17) {
        progressValue = 86;
      }
      if (currentStepIndex === 18) {
        progressValue = 89;
      }
      if (currentStepIndex === 19) {
        progressValue = 92;
      }
      if (currentStepIndex === 20) {
        progressValue = 95;
      }
      if (currentStepIndex === 21) {
        progressValue = 98;
      }
    }

    if (customV3) {
      if (currentStepIndex < 5 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 5 && currentStepIndex <= 10 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 10 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV4 || customV10 || customV13) {
      if (currentStepIndex < 6 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 10 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 11 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV5) {
      if (currentStepIndex < 6 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 10 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 11 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV21) {
      if (currentStepIndex < 5 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 13 && title !== T('customV2_progress_text8')) {
        setTitle(T('customV2_progress_text8'));
      }
    } else if (customV20) {
      if (currentStepIndex < 6 && title !== T('customV2_progress_text5')) {
        setTitle(T('customV2_progress_text5'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 12 && title !== T('customV2_progress_text6')) {
        setTitle(T('customV2_progress_text6'));
      }
      if (currentStepIndex > 12 && title !== T('customV2_progress_text7')) {
        setTitle(T('customV2_progress_text7'));
      }
    } else if (customV24) {
      if (currentStepIndex < 6 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 10 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 10 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV28) {
      if (currentStepIndex < 7 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 7 && currentStepIndex <= 13 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 13 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV32) {
      if (currentStepIndex < 6 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 8 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 8 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV2 && everydoggyV5 && !tariff && firstScreenAB) {
      if (currentStepIndex < 6 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 11 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 11 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV2 && everydoggyV5 && tariff && p13MixFirstScreenTitle) {
      if (currentStepIndex < 7 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 7 && currentStepIndex <= 12 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 12 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV43) {
      if (currentStepIndex < 8 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 8 && currentStepIndex <= 13 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 13 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else if (customV44) {
      if (currentStepIndex < 7 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 7 && currentStepIndex <= 14 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 14 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    } else {
      if (currentStepIndex < 6 && title !== T('customV2_progress_text1')) {
        setTitle(T('customV2_progress_text1'));
      }
      if (currentStepIndex >= 6 && currentStepIndex <= 11 && title !== T('customV2_progress_text2')) {
        setTitle(T('customV2_progress_text2'));
      }
      if (currentStepIndex > 11 && title !== T('customV2_progress_text3')) {
        setTitle(T('customV2_progress_text3'));
      }
    }

    setProgress(-100 + progressValue);
  }, [currentStep]);

  return (
    <div className={s.progressBarWrapper}>

      {sv2 || everydoggyV5 && !tariff && firstScreenAB ? (
        <p className={s.progressBarText}>{title} {titleNumberStep}</p>
      ) : (
        <p className={s.progressBarText}>{title}</p>
      )}
      
      <div className={s.progressBlock}>
        <div
          className={`${s.progressBar}`}
          style={{
            transform: `translateX(${progress}%)`,
          }}
        />
        <div className={s.progressBarDividers}>
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
        </div>
        <div className={s.progressBarLines}>
          <div className={s.progressBarLine} />
          <div className={s.progressBarLine} />
          <div className={s.progressBarLine} />
        </div>
      </div>
    </div>
  );
}

export default ProgressBarV2;
